"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var integralMall_1 = require("../../model/integralMall");
var service_1 = require("../../../library/base/service");
var MyList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MyList, _super);
    function MyList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '自有商品列表';
        _this.code = '300412';
        _this.desc = '自有商品列表';
        _this.requestParams = new integralMall_1.MyListRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return MyList;
}(service_1.BaseService));
exports.MyList = MyList;
//# sourceMappingURL=myList.js.map